import { render, staticRenderFns } from "./datatables_class_template.vue?vue&type=template&id=bf402434&"
import script from "./datatables_class_template.vue?vue&type=script&lang=js&"
export * from "./datatables_class_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports